var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppe-form',{attrs:{"entityName":"Operation","title":"Projet / Opération","title-field":"","sub-title":"","schema":_vm.schema,"endpoint":_vm.endpoint,"redirect":'/ppe_eu/operation_home/:id'},on:{"dataLoaded":_vm.onDataLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }